import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/compact/flex.png";
import type { Product } from "../../types";
import { productListSwitchingCompact } from "../product-list-groups/productListSwitchingCompact";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  ports,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const flex: Product = {
  id: "flex",
  productTitle: "Flex",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-flex"],
  storePathParts: { productSlug: "usw-flex", category: "switching-utility" },
  sku: "USW-Flex",
  description: "flex.description",
  descriptionMaxWidth: 150,
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '122.5 x 107.1 x 28 mm\n(4.8 x 4.2 x 1.1")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "5" },
    },
    {
      propertyId: ports.id,
      value: { type: "string", value: "(5) GbE RJ45" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "Up to 46 W" },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "flex.powerMethod",
      },
    },
    {
      propertyId: mounting.id,
      value: { type: "translation", value: "flex.mounting" },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: true },
    },
  ],
};
